import { render, staticRenderFns } from "./DeleteReadNotifications.vue?vue&type=template&id=e140245a"
import script from "./DeleteReadNotifications.vue?vue&type=script&lang=ts"
export * from "./DeleteReadNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e140245a')) {
      api.createRecord('e140245a', component.options)
    } else {
      api.reload('e140245a', component.options)
    }
    module.hot.accept("./DeleteReadNotifications.vue?vue&type=template&id=e140245a", function () {
      api.rerender('e140245a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/DeleteReadNotifications.vue"
export default component.exports